//
export function dealWithBooking (obj, item, answerId) {
    if (!item.onlineBooking) {
        // TODO error & snackbar here ?
        return
    }
    // this service is OnlineBooking, so we need to trigger the booking window
    // console.log('WE NEED TO DO SOMETHING TO BOOK')
    obj.dialogOnlineBooking = true
    obj.ServiceIDforOnlineBooking = item.id
    // navigate(obj, 'EndUserMyServices')
    if (answerId !== '') {
        obj.answerId = answerId
    }
}
